//Painting Details 
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getMethod, } from '../../services/apiService';
import { IMG_URL } from '../../utility/config';
import LoadingSpinner from '../../utility/LoadingSpinner';

function Paintingdetails() {
  const { id } = useParams();
  const [painting, setPainting] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const PaintingIMG = IMG_URL
  const navigate = useNavigate();

  //Display painting
  useEffect(() => {
    const fetchPainting = async () => {
      const response = await getMethod(`paintings/${id}`);
      if (response && response.status) {
        setPainting(response.data);
      } else {
        console.error('Failed to fetch painting by ID:', response.error || response);
      }
      setLoading(false);
    };

    fetchPainting();
  }, [id]);


  if (error) {
    return <div>{error}</div>;
  }

  if (loading) return <LoadingSpinner />;

  const handleClick = () => {
    navigate(`/buyerszone?tab=Paintings`);  // Navigate with query param & path, query, key=value pair
  };

  return (
    <div className="painting-padding">
      <br></br>
      <h2 className="poems__title_details10"><span> </span></h2>
      {painting.image_url && (
        <img className="paintingdetails_img"
          src={`${PaintingIMG}/${painting.image_url}`}
          alt={painting.title}
        />
      )}
      <h2 className="painting-details_h2"
        dangerouslySetInnerHTML={{ __html: painting.title }}
      />
      <p className="painting-details_p"
        dangerouslySetInnerHTML={{ __html: painting.long_description }}
      />

      <button onClick={(e) => handleClick()} className="poem-card__button">
        Buyer's Zone
      </button>

    </div>
  );
}

export default Paintingdetails;